import { render } from "./registrationStep6.vue?vue&type=template&id=23767ae8&scoped=true"
import script from "./registrationStep6.vue?vue&type=script&lang=js"
export * from "./registrationStep6.vue?vue&type=script&lang=js"

import "./registrationStep6.vue?vue&type=style&index=0&id=23767ae8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23767ae8"]])

export default __exports__